var exports = {
  "GA": "instructions__0qB50L",
  "Z4": "instructionsHeader__6p402s",
  "Pz": "instructionsIcon__ZqtEqb",
  "o0": "instructionsTitle___RCgxa",
  "nz": "instructionsContent__hipSmE",
  "ip": "instructionsEmptyState__WLDX5M",
};

module.exports = exports;
